import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  label: {
    fontSize: theme.size.sm
  }
}))

export default useStyles
